module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "part",
      "role": "doc-part"
    }
  }, [_c('div', {
    staticClass: "sidebar1"
  }, [_c('h1', {
    staticClass: "h1part"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 3",
      "epub:type": "pagebreak",
      "id": "page_3",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    staticClass: "f1"
  }, [_vm._v("PART I")]), _vm._v(" "), _c('span', {
    staticClass: "heading_break"
  }, [_vm._v("IN THE BEGINNING")])])])]), _vm._v(" "), _c('h2', {
    staticClass: "h2a",
    attrs: {
      "id": "lev01"
    }
  }, [_vm._v("Big Bang")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The first first, more or less by definition, was the Big Bang of some 13.8 billion years ago that created time, the universe… and everything. Everything? Even whatever it was that went bang? Let’s not go there…")]), _vm._v(" "), _c('h2', {
    staticClass: "h2a",
    attrs: {
      "id": "lev02"
    }
  }, [_vm._v("Life")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The first "), _c('b', [_vm._v("life on Earth")]), _vm._v("—a much easier concept—is thought to have emerged 4.28 billion years ago, when our young planet was celebrating its 26 millionth birthday. Scientists refer to this first “life thing” (the simplest of microorganisms) as LUCA—the Last Universal Common Ancestor. Apparently, we’re all descended from LUCA.")]), _vm._v(" "), _c('h2', {
    staticClass: "h2a",
    attrs: {
      "id": "lev03"
    }
  }, [_vm._v("“Handy Man”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("LUCA’s descendants took a very long time to evolve into the "), _c('b', [_vm._v("genus")]), _vm._v(" "), _c('i', [_vm._v("Homo")]), _vm._v(", which appeared only about 2.1 million years ago. Its identifying features were an ape-like physiognomy, a bulging brain, and an ability to use primitive "), _c('b', [_vm._v("tools")]), _vm._v(" (another first)—hence its name, "), _c('i', [_vm._v("Homo habilis")]), _vm._v(" or “handy man.”")]), _vm._v(" "), _c('h2', {
    staticClass: "h2a",
    attrs: {
      "id": "lev04"
    }
  }, [_vm._v("Upright, Fire, Tools, and Speech")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("About 200,000 years later, "), _c('i', [_vm._v("Homo erectus")]), _vm._v(" (“upright man”) had developed. This creature’s even larger brain may have "), _c('span', {
    attrs: {
      "aria-label": "page 4",
      "epub:type": "pagebreak",
      "id": "page_4",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("enabled it to speak (if so, we have the first "), _c('b', [_vm._v("language")]), _vm._v("). The species had possibly learned to handle "), _c('b', [_vm._v("fire")]), _vm._v(" (one more first, see "), _c('a', {
    attrs: {
      "href": "#/e9781646040988/xhtml/part02#page_11"
    }
  }, [_vm._v("page 11")]), _vm._v(") and certainly made tools of greater sophistication; it was also spreading out from Africa to populate the globe.")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2a",
    attrs: {
      "id": "lev05"
    }
  }, [_vm._v("Homo Sapiens")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("We’re not quite sure what happened next. However, from among the variety of "), _c('i', [_vm._v("Homo")]), _vm._v(" types, by "), _c('i', [_vm._v("c.")]), _vm._v(" 50,000 BC "), _c('i', [_vm._v("Homo sapiens")]), _vm._v(" (“intelligent man”) was hunting and gathering in the inclement conditions of the last glacial period. These were the first modern human beings, forebears of the extraordinarily inquisitive and inventive men and women responsible for the astonishing catalog of firsts that follows.")]), _vm._v(" "), _c('div', {
    staticClass: "inline_groupn",
    attrs: {
      "id": "f0004-01"
    }
  }, [_c('img', {
    staticClass: "landscape_50",
    attrs: {
      "alt": "Image",
      "src": "e9781646040988/images/f0004-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The skulls of "), _c('i', [_vm._v("Homo sapiens")]), _vm._v(" (left) and of his unsuccessful relative, "), _c('i', [_vm._v("Homo neanderthalensis")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aaa6d42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781646040988/xhtml/part01.vue
// module id = 69
// module chunks = 0